var map = {
	"./ac.svg": "f9ae",
	"./ac2.svg": "4633",
	"./action.svg": "0ce9",
	"./attack.svg": "1364",
	"./combat.svg": "73e2",
	"./dialogue.svg": "741e",
	"./journal.svg": "98ab",
	"./location.svg": "dc56",
	"./lose.svg": "911f",
	"./miss.svg": "c0d7",
	"./roll.svg": "9688",
	"./win.svg": "6a70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f991";